import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Spin } from 'antd';

const ConfirmationModal = ({ title, message, show, commonState, showHide, action }) => {
    return (
        <Modal show={show} onHide={showHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Spin spinning={commonState.blocking > 0} size="large" >
                    <Button onClick={showHide}>Chiudi</Button>
                    <Button bsStyle='primary' onClick={action}>Conferma</Button>
                </Spin>
            </Modal.Footer>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    title: PropTypes.string.isRequired, // title
    message: PropTypes.string.isRequired, // message
    show: PropTypes.bool.isRequired, // show
    showHide: PropTypes.func.isRequired, // anction on hide
    action: PropTypes.func.isRequired, // anction on click
    commonState: PropTypes.object.isRequired // the Redux common state
};

export default ConfirmationModal;
